import React from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { getLang } from 'redux-pagan';
import compose from 'lodash/flowRight';

import RealtorLandingContactFormComponent
  from './RealtorLandingContactFormComponent';

import { sendContactUsForm } from '../../redux/modules/contactUs';
import { hideMessageModal, openMessageModal } from '../../redux/modules/messageModal';

import checkRtlLanguage from '../../utils/checkRtlLanguage';
import validate from './validate';

const mapStateToProps = state => ({
  translate: getLang(state.lang, 'static'),
  locale: state.lang.locale,
  isMobile: state.windowDimentions.isMobile,
  isRtl: checkRtlLanguage(state.lang.locale),
  userData: state.userAuthentication.data,
  contactUs: state.contactUs,
  isMessageModalOpen: state.messageModal.isMessageModalOpen
});

export default compose(
  connect(mapStateToProps, {
    sendContactUsForm,
    openMessageModal,
    hideMessageModal
  }),
  reduxForm({
    form: 'realtorLandingContactFormModal',
    validate
  })
)(RealtorLandingContactFormComponent);
